import { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function EventRedirectPage() {
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/hosted-events/${eventId}`)
      .then(r => {
        const ev = r.data.event || r.data;
        const city = (ev.city_slug || ev.city || 'events').toString().toLowerCase().replace(/\s+/g, '-');
        const slug = ev.slug || eventId;
        const src = searchParams.get('src');
        window.location.replace(`/events/${city}/${slug}${src ? `?src=${src}` : ''}#tickets`);
      })
      .catch(() => setError('Event not found'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId]);

  if (error) return <div className="min-h-screen flex items-center justify-center text-muted-foreground">{error}</div>;
  return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;
}
